/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalnotify_Error_TitleInputs */

const en_portalnotify_error_title = /** @type {(inputs: Portalnotify_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications did not load`)
};

/** @type {(inputs: Portalnotify_Error_TitleInputs) => LocalizedString} */
const ar_portalnotify_error_title = en_portalnotify_error_title;

/** @type {(inputs: Portalnotify_Error_TitleInputs) => LocalizedString} */
const he_portalnotify_error_title = en_portalnotify_error_title;

/** @type {(inputs: Portalnotify_Error_TitleInputs) => LocalizedString} */
const ur_portalnotify_error_title = en_portalnotify_error_title;

/** @type {(inputs: Portalnotify_Error_TitleInputs) => LocalizedString} */
const es_portalnotify_error_title = en_portalnotify_error_title;

/** @type {(inputs: Portalnotify_Error_TitleInputs) => LocalizedString} */
const fr_portalnotify_error_title = en_portalnotify_error_title;

/** @type {(inputs: Portalnotify_Error_TitleInputs) => LocalizedString} */
const de_portalnotify_error_title = en_portalnotify_error_title;

/** @type {(inputs: Portalnotify_Error_TitleInputs) => LocalizedString} */
const pt_portalnotify_error_title = en_portalnotify_error_title;

/** @type {(inputs: Portalnotify_Error_TitleInputs) => LocalizedString} */
const hi_portalnotify_error_title = en_portalnotify_error_title;

/** @type {(inputs: Portalnotify_Error_TitleInputs) => LocalizedString} */
const bn_portalnotify_error_title = en_portalnotify_error_title;

/**
* | output |
* | --- |
* | "Notifications did not load" |
*
* @param {Portalnotify_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalnotify_error_title = /** @type {((inputs?: Portalnotify_Error_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalnotify_Error_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalnotify_error_title(inputs)
	if (locale === "he") return he_portalnotify_error_title(inputs)
	if (locale === "ur") return ur_portalnotify_error_title(inputs)
	if (locale === "es") return es_portalnotify_error_title(inputs)
	if (locale === "fr") return fr_portalnotify_error_title(inputs)
	if (locale === "de") return de_portalnotify_error_title(inputs)
	if (locale === "pt") return pt_portalnotify_error_title(inputs)
	if (locale === "hi") return hi_portalnotify_error_title(inputs)
	if (locale === "bn") return bn_portalnotify_error_title(inputs)
	return /** @type {LocalizedString} */ ("Notifications did not load")
});